import { useCallback, useState } from 'react'

export const useSearchAndPage = () => {
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [search, setSearch] = useState('')

  const handleSearch = useCallback((search: string) => {
    setSearch(search)
    setPage(0)
  }, [])

  return {
    page,
    pageSize,
    search,
    setPage,
    setPageSize,
    handleSearch,
    searchAndPageParams: { skip: page * pageSize, max: pageSize, query: search },
  }
}
